import React, { useState, useContext, useEffect } from 'react'

import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'
import { DateTimePicker } from '@material-ui/pickers'
import { Switch } from '@material-ui/core'

import dayjs from 'dayjs'
import AutoStreamTracksCheckedList from '../AutoStreamTracks/AutoStreamTracksCheckedList'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

const allLanguages = 'allLanguages'

export default React.memo(function CustomAppointmentForm(props) {
    const { visible, handleClose, appointmentMeta, autoTracks, languageList } =
        props
    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)
    const classes = useStyles()

    const stream = appointmentMeta.data

    const [performingAction, setPerformingAction] = useState(true)
    const [name, setName] = useState(stream.name || '')
    const [description, setDesc] = useState(stream.description || '')
    const [startDate, setStartDate] = useState(dayjs(stream.startDate))
    const [endDate, setEndDate] = useState(dayjs(stream.endDate))
    const [streamStatus, setStreamStatus] = useState(
        stream.streamStatus || 'regular'
    )

    const [auto, setAuto] = useState(stream.auto)
    const [autoRecordsPaths, setAutoRecordsPaths] = useState(
        stream.autoRecordsPaths || []
    )
    const [checkedTracks, setCheckedTracks] = useState([])
    const [initialAllAutoPaths, setInitialAllAutoPaths] = useState([])
    const [shouldPlayAllTracks, setShouldPlayAllTracks] = useState(true)

    const [locale, setLocale] = useState(stream.locale || allLanguages)

    useEffect(() => {
        setInitialAllAutoPaths(autoTracks.map((track) => track.url))
    }, [autoTracks])

    useEffect(() => {
        const autoRecordPaths = firebaseContext.data.autoRecordPaths[stream.id]
        if (!autoRecordPaths) {
            return
        }

        setAutoRecordsPaths(initialAllAutoPaths)
        setCheckedTracks(autoTracks)
        setShouldPlayAllTracks(true)

        if (autoRecordPaths && autoRecordPaths.length) {
            setAutoRecordsPaths(autoRecordPaths)

            const checkedResult = []
            autoRecordPaths.map((autoRecordPath) => {
                const autoTrackIndex = autoTracks.findIndex(
                    (autoTrack) => autoRecordPath === autoTrack.url
                )
                if (autoTrackIndex !== -1) {
                    checkedResult.push(autoTracks[autoTrackIndex])
                }
                return true
            })
            setCheckedTracks(checkedResult)
            setShouldPlayAllTracks(false)
        }
    }, [stream, autoTracks, firebaseContext.data.autoRecordPaths[stream.id]])

    const handleAutoChange = (event) => {
        setAuto(Boolean(event.target.checked))

        if (event.target.checked) {
            setShouldPlayAllTracks(true)
        }
    }

    const [errors, setErrors] = useState({
        name: false,
        description: false,
        startDate: false,
        endDate: false,
    })

    const handleNameChange = (event) => {
        const val = event.target.value
        setName(event.target.value)
        if (val === '') {
            setErrors({
                ...errors,
                name: 'Наименование стрима не может быть пустым',
            })
        } else {
            setErrors({
                ...errors,
                name: false,
            })
        }
    }
    const handleDescChange = (event) => {
        setDesc(event.target.value)
    }

    const handleStartDateError = (error, value) => {
        if (error === '' && !errors.startDate) return
        if (error === errors.startDate) return

        if (error !== '') setErrors({ ...errors, startDate: error })
        else setErrors({ ...errors, startDate: false })
    }
    const handleEndDateError = (error, value) => {
        if (error === '' && !errors.endDate) return
        if (error === errors.endDate) return

        if (error !== '') setErrors({ ...errors, endDate: error })
        else setErrors({ ...errors, endDate: false })
    }

    const getAutoRecordsPaths = () => {
        return auto ? (shouldPlayAllTracks ? [] : autoRecordsPaths) : []
    }

    const handleSave = async (event) => {
        if (stream.status !== 'bound') {
            appContext.snackbar.showSnackbarMsg(
                'Нельзя редактировать начатый стрим'
            )
            return
        }

        handleClose()
        const updatedStream = {
            name,
            description,
            startDate: new Date(startDate.toString()),
            endDate: new Date(endDate.toString()),
            status: 'bound',
            streamStatus: streamStatus,
            bgImage: firebaseContext.getStreamPictureByDate(startDate),
            auto: auto || false,
            converted: false,
        }

        if (locale !== allLanguages) updatedStream.locale = locale

        const streamePrivateKeyUpdateResult =
            await firebaseContext.updateStreamAutoRecordsPaths(
                stream.id,
                getAutoRecordsPaths()
            )

        if (streamePrivateKeyUpdateResult.error) {
            appContext.snackbar.showSnackbarMsg(
                streamePrivateKeyUpdateResult.message
            )
            return
        }

        const result = await firebaseContext.updateStream(
            stream.id,
            updatedStream
        )

        firebaseContext.updateStreamTranslations(stream.id)

        if (!result.error) {
            firebaseContext.changeData.setAutoRecordPaths({
                ...firebaseContext.data.autoRecordPaths,
                [stream.id]: getAutoRecordsPaths(),
            })
        }

        appContext.snackbar.showSnackbarMsg(result.message)
    }

    const handleStreamStatusChange = (event) => {
        setStreamStatus(event.target.value)
    }

    const renderStreamImage = () => {
        const bgPicture = firebaseContext.getStreamPictureByDate(startDate)
        return (
            <>
                {bgPicture && (
                    <img className={classes.coverImage} src={bgPicture} />
                )}
            </>
        )
    }

    const playAllTracksSwitchHandler = (event) => {
        setShouldPlayAllTracks(event.target.checked)

        if (event.target.checked) {
            setAutoRecordsPaths([])
        } else {
            setAutoRecordsPaths(checkedTracks.map((track) => track.url))
        }
    }

    const handleCheckboxInversion = () => {
        const newCheckedTracks = [...checkedTracks]

        autoTracks.map((track) => {
            const isTrackCheckedIndex = checkedTracks.indexOf(track)
            if (isTrackCheckedIndex === -1) {
                newCheckedTracks.push(track)
            } else {
                newCheckedTracks.splice(track, 1)
            }

            return true
        })

        setAutoRecordsPaths(newCheckedTracks.map((track) => track.url))
        setCheckedTracks(newCheckedTracks)
    }

    const handleToggleTrackCheckbox = (value) => () => {
        const currentIndex = checkedTracks.indexOf(value)
        const newCheckedTracks = [...checkedTracks]

        if (currentIndex === -1) {
            newCheckedTracks.push(value)
        } else {
            newCheckedTracks.splice(currentIndex, 1)
        }

        setAutoRecordsPaths(newCheckedTracks.map((track) => track.url))
        setCheckedTracks(newCheckedTracks)
    }

    return (
        <Dialog
            open={visible}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">Настройки стрима</DialogTitle>
            <DialogContent>
                <List>
                    <ListItem>
                        {/* <Hidden xsDown>
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                        </Hidden> */}
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.name)}
                            fullWidth
                            label="Наименование стрима"
                            required
                            type="text"
                            value={name}
                            helperText={errors.name || ''}
                            onChange={handleNameChange}
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            disabled={!performingAction}
                            fullWidth
                            label="Описание стрима"
                            type="text"
                            value={description}
                            onChange={handleDescChange}
                        />
                    </ListItem>
                    <ListItem>
                        <InputLabel id="language" shrink>
                            Язык стрима
                        </InputLabel>
                        <Select
                            labelId="language"
                            value={locale}
                            onChange={(newValue) =>
                                setLocale(newValue.target.value)
                            }
                        >
                            {languageList &&
                                languageList.map((language) => (
                                    <MenuItem
                                        value={language.id}
                                        key={language.id}
                                    >
                                        {language.data.represent}
                                    </MenuItem>
                                ))}
                        </Select>
                    </ListItem>
                    <ListItem className={classes.listItem}>
                        <div className={classes.listItem__left}>
                            <div className={classes.listItem__leftDate}>
                                <DateTimePicker
                                    className={classes.listItem__leftDatePicker}
                                    ampm={false}
                                    value={startDate}
                                    onChange={setStartDate}
                                    onError={handleStartDateError}
                                    format="MMMM, D HH:mm"
                                    label="Время начала стрима"
                                    cancelLabel="Отмена"
                                    okLabel="Сохранить"
                                    invalidDateMessage="Некорректная дата"
                                    minDateMessage="Недопустимое значение"
                                    maxDateMessage="Недопустимое значение"
                                    disablePast
                                    strictCompareDates
                                />
                            </div>
                            <div className={classes.listItem__leftDate}>
                                <DateTimePicker
                                    className={classes.listItem__leftDatePicker}
                                    ampm={false}
                                    value={endDate}
                                    onChange={setEndDate}
                                    minDate={startDate.add(1, 'minute')}
                                    maxDate={startDate.add(23, 'hour')}
                                    onError={handleEndDateError}
                                    format="MMMM, D HH:mm"
                                    label="Время окончания стрима"
                                    cancelLabel="Отмена"
                                    okLabel="Сохранить"
                                    minDateMessage="Недопустимое значение"
                                    maxDateMessage="Недопустимое значение"
                                    invalidDateMessage="Некорректная дата"
                                    disablePast
                                    strictCompareDates
                                />
                            </div>
                            <div className={classes.listItem__leftStatus}>
                                <InputLabel shrink id="stream-status">
                                    Статус стрима
                                </InputLabel>
                                <Select
                                    value={streamStatus}
                                    onChange={handleStreamStatusChange}
                                    labelId="stream-status"
                                >
                                    <MenuItem value="vip">VIP</MenuItem>
                                    <MenuItem value="free">Бесплатно</MenuItem>
                                </Select>
                            </div>
                        </div>
                        <div className={classes.listItem__right}>
                            {renderStreamImage()}
                        </div>
                    </ListItem>
                    <ListItem className={classes.listItem__tracks}>
                        <FormControlLabel
                            label="Автоматический стрим"
                            control={
                                <Checkbox
                                    checked={auto}
                                    onChange={handleAutoChange}
                                />
                            }
                        />
                        {auto && (
                            <div className={classes.switchPlayAll}>
                                <div>
                                    <Switch
                                        id={'switch-auto-stream-play-all'}
                                        color={'primary'}
                                        checked={shouldPlayAllTracks}
                                        onChange={playAllTracksSwitchHandler}
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor={'switch-auto-stream-play-all'}
                                    >
                                        Проигрывать все треки
                                    </label>
                                </div>
                            </div>
                        )}
                        {auto && !shouldPlayAllTracks && (
                            <Button
                                onClick={handleCheckboxInversion}
                                color="primary"
                            >
                                Инвертирование выделения
                            </Button>
                        )}
                        {auto && !shouldPlayAllTracks && (
                            <AutoStreamTracksCheckedList
                                autoTracks={autoTracks}
                                checkedTracks={checkedTracks}
                                handleToggleTrackCheckbox={
                                    handleToggleTrackCheckbox
                                }
                            />
                        )}
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Отмена
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    disabled={
                        !!(
                            errors.name ||
                            errors.startDate ||
                            errors.endDate ||
                            (auto &&
                                !shouldPlayAllTracks &&
                                !autoRecordsPaths.length)
                        )
                    }
                >
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    )
})

const useStyles = makeStyles((theme) => ({
    listItem: {
        flexWrap: 'wrap',
    },
    listItem__left: {
        width: '50%',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginBottom: 16,
        },
    },
    listItem__leftDate: {
        width: '100%',
        marginBottom: 16,
    },
    listItem__leftDatePicker: {
        maxWidth: 200,
        width: '100%',
    },
    listItem__leftStatus: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
    },
    listItem__right: {
        display: 'flex',
        width: '50%',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            justifyContent: 'flex-start',
        },
    },
    listItem__tracks: {
        flexWrap: 'wrap',
    },
    switchPlayAll: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            marginLeft: -11,
        },
    },
    coverImage: {
        maxWidth: '200px',
        maxHeight: '200px',
        width: 'auto',
        height: 'auto',
        objectFit: 'cover',
    },
    bottomAutoTracksList: {
        width: '100%',
    },
}))
